enum PRINT_TEMPLATES {
    SALES_INVOICE = "SalesInvoice.docx",
    PACKING_SLIP = "PackingSlip.docx",
    DELIVERY_PACKING_SLIP = "DeliveryPickingSlip.docx",
    DELIVERY_DOCUMENT = "Delivery_Note.docx"
}

export default PRINT_TEMPLATES